export default __webpack_public_path__ + "static/media/download.a51db226.svg";